import { isLoveMailru } from 'common/constants'

import { loginVariantsPath, loginPath } from './boarding.paths'

export const getLoginPath = (partnerId: number) => {
  return isLoveMailru(partnerId) ? loginPath : loginVariantsPath
}
